// eslint-disable-next-line import/no-unresolved, import/extensions
import Privacy from './PrivacyFlowV2';

export default Privacy;
